<script setup>
import { computed } from 'vue'

const props = defineProps({
  options: { required: true },
  item: { required: true },
  dirtyClass: { required: false, default: '' },
  editable: { required: false, default: true }
})
const emit = defineEmits(['update', 'addDirty'])
const propModel = computed({
  get() {
    return getReferencePoint(props.item)
  },
  set(value) {
    emit('update', { oldId: props.item, newId: value })
    emit('addDirty')
  }
})
const getReferencePoint = (referencePoint) => {
  return props.options.find((item) => referencePoint === item.id)
}
</script>

<template>
  <div class="text-container">
    <v-select
      v-if="editable"
      :class="`${dirtyClass} mt-0 default-text-color text-field`"
      hide-selected
      :items="options"
      item-value="id"
      item-title="properties.name"
      density="compact"
      v-model="propModel"
      item-disabled="disabled"
      hide-details
      solo
      variant="plain"
    >
      <template v-slot:selection="{ item, props }">
        <v-list-item class="text-field pl-1" density="compact" v-bind="props">
          {{ item.title }}
        </v-list-item>
      </template>
      <template v-slot:item="{ item, props }">
        <v-list-item
          :disabled="item.raw.disabled"
          class="text-field pl-3"
          density="compact"
          v-bind="props"
        >
        </v-list-item>
      </template>
    </v-select>
    <div v-else :class="[dirtyClass, 'pl-1']">
      <span>
        {{ propModel ? propModel.properties.name : null }}
      </span>
    </div>
  </div>
</template>

<style scoped>
.text-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

:deep(.v-list-item--disabled) {
  opacity: unset;
}

:deep(.v-list-item-title) {
  font-size: 14px;
}

:deep(.v-field__input) {
  padding-top: 0 !important;
}

:deep(.v-field__append-inner) {
  padding-top: 4px !important;
}

.custom input[type='number'] {
  -moz-appearance: textfield;
}

.default-text-color * {
  color: rgb(0 0 0 / 87%) !important;
}
</style>
